import _ from "lodash";
import { useCallback, useState, useRef } from "react";

const useDebouncedSearch = (callback, delay = 900) => {
  const [searchTerm, setSearchTerm] = useState("");
  const previousValue = useRef(""); // Store the previous search term

  const debouncedSearch = useCallback(
    _.debounce((value) => {
      const trimmedValue = value.trim();
      if (trimmedValue !== previousValue.current) {
        // Check for changes
        previousValue.current = trimmedValue; // Update previous value
        setSearchTerm(trimmedValue);
        callback(trimmedValue);
      }
    }, delay),
    [callback, delay]
  );

  const handleSearchChange = (event) => {
    debouncedSearch(event.target.value);
  };

  return [searchTerm, handleSearchChange];
};

export default useDebouncedSearch;
